import React, { ReactElement, useContext, useEffect } from 'react'
import Divider from '@/components/Divider'
import ListingOverview from '@/components/airdrop/ListingOverview'
import { Context } from '@/components/Context'
import Link from 'next/link'
import { BsTwitterX } from 'react-icons/bs'
import { UpdateType } from '@/types/websocket'

const AirdropOverview = (): ReactElement => {
    const { setActiveUpdates } = useContext(Context)

    useEffect(() => {
        setActiveUpdates([UpdateType.AUCTIONS])
    }, [])

    return (
        <div>
            <h1 className={'title'}>Apply for an Airdrop</h1>
            <h4 className={'title gray '}>
                <span className={'yellow-text'}>&#11042;&nbsp;</span>
                Reply&nbsp;on&nbsp;X&nbsp;with&nbsp;your&nbsp;wallet
                <span className={'red-text'}>&nbsp;&#11042;&nbsp;</span>
                Follow
                <span className={'pink'}>&nbsp;&#11042;&nbsp;</span>
                Like
                <span className={'blue'}> &#11042;&nbsp;</span>
                Retweet
                <span className={'pale-blue'}> &#11042;&nbsp;</span>
                Tag&nbsp;a&nbsp;friend&nbsp;
            </h4>
            <div>
                <div className={'bottom white'}>
                    <Divider />
                </div>
                <div className={'gray'}>The Airdrop is a fixed percentage of the auction sale.</div>
                <div className={'gray'}>
                    To be applicable you need to at least reply and be following YourToken.Art on&nbsp;
                    <Link href="https://www.x.com/yourtokenart" target="_blank" rel="noopener noreferrer">
                        <BsTwitterX className="social-media-icon margin-top-five gray border mdeium z-index-hundred" />
                    </Link>
                </div>
                <div className={'gray'}>A reply weighs 1. A like weighs 1. A retweet weighs 2. A tag weighs 5.</div>
                <div className={'gray'}>Distribution of the Airdrop depends on your combined weighs.</div>
                <div className={'padding-five'}></div>
                <div>
                    <ListingOverview />
                </div>
            </div>
        </div>
    )
}

export default AirdropOverview
